module.exports = __webpack_public_path__ + "img/whatisfigma.e1ed1fb3.jpg";